// import cookie from 'react-cookies';
import cookie from 'react-cookies';

function parseCookieValue(value) {
  if (!value || typeof value !== 'string') return value || null;

  try {
    return JSON.parse(value);
  } catch {
    return value;
  }
}

function getSessionFromCookies() {
  const userCookie = parseCookieValue(cookie.load('user'));
  const tokenCookie = parseCookieValue(cookie.load('token'));

  if (userCookie && userCookie.token && userCookie.user) {
    return userCookie;
  }

  if (userCookie && tokenCookie) {
    return {
      token: tokenCookie,
      user: userCookie,
    };
  }

  return null;
}

function getCookieOptions(age, hostname) {
  const domain = resolveSharedCookieDomain(hostname);
  const cookieOptions = {
    path: '/',
    maxAge: age || 100000,
  };

  if (domain) cookieOptions.domain = domain;
  return cookieOptions;
}

function storeUserSessionCookies(itemValue, age, hostname) {
  if (!itemValue || !itemValue.user || !itemValue.token) return;

  const cookieOptions = getCookieOptions(age, hostname);
  cookie.save('user', JSON.stringify(itemValue.user), cookieOptions);
  cookie.save('token', itemValue.token, cookieOptions);
}

function storeUserProfileLocally(user) {
  localStorage.setItem('user', JSON.stringify({user}));
}

export function resolveSharedCookieDomain(hostname) {
  const normalizedHostname = (hostname ||
    (typeof window !== 'undefined' ? window.location.hostname : '') ||
    ''
  )
    .split(':')[0]
    .toLowerCase();

  if (
    normalizedHostname === 'jidipi.local' ||
    normalizedHostname.endsWith('.jidipi.local')
  ) {
    return '.jidipi.local';
  }

  if (
    normalizedHostname === 'dev.jidipi.com' ||
    normalizedHostname.endsWith('.dev.jidipi.com')
  ) {
    return '.dev.jidipi.com';
  }

  if (
    normalizedHostname === 'jidipi.com' ||
    normalizedHostname.endsWith('.jidipi.com')
  ) {
    return '.jidipi.com';
  }

  return null;
}

export function storeLocally(itemName, itemValue, age, hostname) {
  if (itemName === 'user' && itemValue && itemValue.user) {
    storeUserProfileLocally(itemValue.user);
    storeUserSessionCookies(itemValue, age, hostname);
    return;
  }

  localStorage.setItem(itemName, JSON.stringify(itemValue));
  cookie.save(
    itemName,
    JSON.stringify(itemValue),
    getCookieOptions(age, hostname)
  );
}

export function getJsonFromLocalStorage(key) {
  if (key === 'user') {
    const cookieSession = getSessionFromCookies();
    if (cookieSession) {
      storeUserProfileLocally(cookieSession.user);
      return cookieSession;
    }

    const legacyValue = localStorage.getItem(key);
    if (legacyValue) {
      const legacySession = JSON.parse(legacyValue);
      if (legacySession && legacySession.token && legacySession.user) {
        storeLocally('user', legacySession);
        return legacySession;
      }
    }

    return null;
  }

  const localValue = localStorage.getItem(key);
  if (localValue) {
    return JSON.parse(localValue);
  }

  return null;

  // return cookie.load(key);
}

export function removeFromLocalStorage(key, hostname) {
  const domain = resolveSharedCookieDomain(hostname);
  const cookieOptions = {
    path: '/',
  };
  const keys = key === 'user' ? ['user', 'token'] : [key];

  if (domain) {
    keys.forEach((cookieKey) => {
      cookie.remove(cookieKey, {
        ...cookieOptions,
        domain,
      });
    });
  }

  keys.forEach((cookieKey) => {
    cookie.remove(cookieKey, cookieOptions);
  });
  return localStorage.removeItem(key);
}
